import React from "react";
import Card from "../../../../components/ui/Card";
import { User, DollarSign, Calendar, Tag, Edit3, ShoppingBag } from "lucide-react";

const FanProfileSidebar = ({ conversation }) => {
  if (!conversation) {
    return (
      <div className="h-full flex items-center justify-center p-6 text-slate-400 bg-white border-l border-slate-200">
        <div className="text-center">
          <User size={48} className="mx-auto mb-3 opacity-20" />
          <p>Select a conversation to view fan details</p>
        </div>
      </div>
    );
  }

  // Mock data augmentation for the prototype
  // In a real app, this would come from a comprehensive user profile query
  const fanDetails = {
    joinDate: "Sep 2024",
    ltv: 12500, // Lifetime Value
    tier: "VIP Circle",
    lastPurchase: "Unity Concert Ticket",
    tags: ["Superfan", "Early Adopter"],
    notes: "Alex loves backend stories. Reach out for beta testing."
  };

  return (
    <div className="h-full bg-white border-l border-slate-200 flex flex-col overflow-y-auto w-80">
      <div className="p-6 text-center border-b border-slate-100">
        <div className="relative inline-block">
            <img
            src={conversation.creatorProfilePictureUrl}
            alt={conversation.creatorName}
            className="w-24 h-24 rounded-full object-cover mb-4 ring-4 ring-slate-50"
            />
            <span className="absolute bottom-4 right-0 w-5 h-5 bg-green-500 border-4 border-white rounded-full"></span>
        </div>
        <h2 className="text-xl font-bold text-slate-800">{conversation.creatorName}</h2>
        <span className="inline-block px-3 py-1 bg-purple-100 text-purple-700 text-xs font-semibold rounded-full mt-2">
            {fanDetails.tier}
        </span>
      </div>

      <div className="p-6 space-y-6">
        {/* Key Stats */}
        <div className="grid grid-cols-2 gap-4">
            <div className="bg-slate-50 p-3 rounded-xl text-center">
                <p className="text-xs text-slate-500 mb-1">Lifetime Value</p>
                <p className="font-bold text-slate-800 flex items-center justify-center gap-1">
                    <DollarSign size={14} className="text-green-600" />
                    {fanDetails.ltv.toLocaleString()}
                </p>
            </div>
            <div className="bg-slate-50 p-3 rounded-xl text-center">
                <p className="text-xs text-slate-500 mb-1">Joined</p>
                <p className="font-bold text-slate-800 flex items-center justify-center gap-1">
                    <Calendar size={14} className="text-blue-500" />
                    {fanDetails.joinDate}
                </p>
            </div>
        </div>

        {/* Tags */}
        <div>
            <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3 flex items-center gap-2">
                <Tag size={12} /> Tags
            </h3>
            <div className="flex flex-wrap gap-2">
                {fanDetails.tags.map(tag => (
                    <span key={tag} className="px-2 py-1 bg-slate-100 text-slate-600 text-xs rounded-md border border-slate-200">
                        {tag}
                    </span>
                ))}
                <button className="px-2 py-1 text-slate-400 text-xs hover:text-purple-600 transition-colors">+ Add</button>
            </div>
        </div>

        {/* Notes */}
        <div>
            <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3 flex items-center gap-2">
                <Edit3 size={12} /> Private Notes
            </h3>
            <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-100 text-sm text-yellow-800 italic">
                "{fanDetails.notes}"
            </div>
        </div>

        {/* Recent Activity */}
        <div>
            <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3 flex items-center gap-2">
                <ShoppingBag size={12} /> Last Purchase
            </h3>
            <div className="flex items-center gap-3 p-3 bg-white border border-slate-100 rounded-lg shadow-sm">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center text-slate-400">
                    <ShoppingBag size={18} />
                </div>
                <div>
                    <p className="text-sm font-semibold text-slate-700">{fanDetails.lastPurchase}</p>
                    <p className="text-xs text-slate-400">2 days ago</p>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default FanProfileSidebar;
